import React, { useState } from "react";
import {
  FormDataKey,
  QuestionAttribute,
  SignUpFormData,
} from "../../../../SignUpFormTypes/signUpFormTypes";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../../helpers/signUpFormConstants";
import FloatingLabelInput from "../../Inputs/FloatingLabelInput";
import InputWrapper from "../../Inputs/InputWrapper";
import UniqueOptions from "./UniqueOptions";

const UniqueChoice: React.FC<QuestionAttribute & { index: number }> = ({
  questionTitle,
  questionDropdownOptions,
  index,
  questionOptional,
}) => {
  const { control, setValue, getValues } = useFormContext<SignUpFormData>();
  const [showOptions, setShowOptions] = useState(false);
  const INPUT_NAME = `questions.${index}.value`;

  const unsetDefaultOption = () => {
    const value = getValues(INPUT_NAME as FormDataKey);
    if (value === "Select one") {
      setValue(INPUT_NAME as FormDataKey, "", {
        shouldValidate: true,
        shouldTouch: true,
        shouldDirty: true,
      });
    }
  };

  const handleShowOptions: React.MouseEventHandler<HTMLInputElement> = e => {
    e.preventDefault();
    e.stopPropagation();
    unsetDefaultOption();
    return setShowOptions(!showOptions);
  };

  const forceBlur: React.MouseEventHandler<HTMLInputElement> = e => {
    if (showOptions) e.currentTarget.blur();
  };

  return (
    <Controller
      name={INPUT_NAME as FormDataKey}
      rules={
        questionOptional
          ? signUpFormValidators.optional
          : signUpFormValidators.notSelectOne
      }
      control={control}
      render={({
        field: { onBlur, value, ...field },
        fieldState: { invalid, isTouched },
      }) => (
        <div className="flex flex-col gap-3 w-full" onClick={handleShowOptions}>
          <InputWrapper
            errorMsg="This field is required."
            hasError={invalid && isTouched && !showOptions && !questionOptional}
            label={questionTitle}
            valid={!invalid && isTouched && !!value && value !== "Select one"}
            valueExists={!!value}
            isSelectInput
            optional={questionOptional}
            name={INPUT_NAME}
          >
            <FloatingLabelInput
              hasError={
                invalid && isTouched && !showOptions && !questionOptional
              }
              readOnly
              isSelectInput
              onClick={forceBlur}
              onBlur={() => {
                setTimeout(() => {
                  unsetDefaultOption();
                  setShowOptions(false);
                  onBlur();
                }, 180);
              }}
              value={value as string}
              {...field}
            />
          </InputWrapper>
          {showOptions && (
            <UniqueOptions
              selected={value as string}
              questionDropdownOptions={questionDropdownOptions}
              setShowOptions={setShowOptions}
              questionFormIdentifier={INPUT_NAME as FormDataKey}
              setValue={setValue}
            />
          )}
        </div>
      )}
    />
  );
};

export default UniqueChoice;
